'use client';

import React from 'react';
import { Building2, MapPin, Users, Bird } from 'lucide-react';
import { MOCK_FARMS } from './farmsData';
import { StatCard } from '@/components/ui/Cards';


export default function FarmsSummaryCards() {
  const totalFarms = MOCK_FARMS?.length;
  const activeFarms = MOCK_FARMS?.filter(f => f?.status === 'active')?.length;
  const totalBranches = MOCK_FARMS?.reduce((s, f) => s + f?.branches?.length, 0);
  const totalBirds = MOCK_FARMS?.reduce((s, f) => s + f?.currentBirds, 0);
  const totalCapacity = MOCK_FARMS?.reduce((s, f) => s + f?.totalCapacity, 0);
  const totalEmployees = MOCK_FARMS?.reduce((s, f) => s + f?.totalEmployees, 0);
  const occupancyPct = totalCapacity > 0 ? Math.round((totalBirds / totalCapacity) * 100) : 0;

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 mb-5">
      <StatCard label="Total Farms" value={totalFarms} sub={`${activeFarms} active`} icon={Building2} iconBg="#f0fdf4" iconColor="#15803d" />
      <StatCard label="Branches / Locations" value={totalBranches} sub="across all farms" icon={MapPin} iconBg="#eff6ff" iconColor="#2563eb" />
      <StatCard label="Total Birds" value={totalBirds?.toLocaleString()} sub={`${occupancyPct}% of capacity`} icon={Bird} iconBg="#fff7ed" iconColor="#c2410c" />
      <StatCard label="Total Employees" value={totalEmployees} sub="across all farms" icon={Users} iconBg="#faf5ff" iconColor="#7c3aed" />
    </div>
  );
}
